<div class="expepharma-vertical-navigation-wrapper">

    <!-- Header -->
    <div class="expepharma-vertical-navigation-header">
        <ng-content select="[expepharmaVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div class="expepharma-vertical-navigation-content" expepharmaScrollbar
        [expepharmaScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}" #navigationContent>

        <!-- Content header -->
        <div class="expepharma-vertical-navigation-content-header">
            <ng-content select="[expepharmaVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <expepharma-vertical-navigation-aside-item [item]="item" [name]="name"
                        [activeItemId]="activeAsideItemId" [autoCollapse]="autoCollapse" [skipChildren]="true"
                        (click)="toggleAside(item)"></expepharma-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic'">
                    <expepharma-vertical-navigation-basic-item [item]="item" [name]="name">
                    </expepharma-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <expepharma-vertical-navigation-collapsable-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></expepharma-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <expepharma-vertical-navigation-divider-item [item]="item" [name]="name">
                    </expepharma-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <expepharma-vertical-navigation-group-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></expepharma-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <expepharma-vertical-navigation-spacer-item [item]="item" [name]="name">
                    </expepharma-vertical-navigation-spacer-item>
                </ng-container>

            </ng-container>

        </ng-container>

        <!-- Content footer -->
        <div class="expepharma-vertical-navigation-content-footer">
            <ng-content select="[expepharmaVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="expepharma-vertical-navigation-footer">
        <ng-content select="[expepharmaVerticalNavigationFooter]"></ng-content>
    </div>

</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div class="expepharma-vertical-navigation-aside-wrapper" expepharmaScrollbar
        [expepharmaScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
        [@fadeInLeft]="position === 'left'" [@fadeInRight]="position === 'right'" [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                    <expepharma-vertical-navigation-aside-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></expepharma-vertical-navigation-aside-item>
                </ng-container>

            </ng-container>

        </ng-container>

    </div>
</ng-container>
